import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';
import {TagButton} from './TagContainer/TagContainer.styled';

export const Wrapper = styled.div`
    position: fixed;
    top:0;
    left:0;
    width:100vw;
    height:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`; 

export const BackgroundOverlay = styled.div<{start?:boolean}>`
    position: fixed;
    top:0;
    left:0;
    width:100vw;
    height:100%;
    z-index: 1;
    transition: opacity 0.5s ease-in-out;
    background:#ffffffb3;
    opacity: ${props => props.start?"1":"0"};
`;

export const Container = styled.div<{start?:boolean}>`
    max-width: 600px;
    width:40vw;
    min-width: 480px;
    height:70vh;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 42px 1fr;
    background:#fff;
    box-shadow: 0 0 4px 1px rgba(0,0,0,0.2);
    border-radius: 5px;
    overflow:hidden;
    position: relative;
    z-index: 2;
    margin-top: - var(--regi-nav-height);
    opacity: ${props => props.start?"1":"0"};
    transform: ${props => props.start?"translateY(0%)":"translateY(20%)"};
    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;

    ${mq(Devices.mobile)} {
        margin:20px 10px;
        width:100%;
        height:90%;
        min-width: unset;
    }
`; 

export const Top = styled.div`
    height:100%;
    display: flex;
    align-items: center;
    background:#2A848E;
    padding:0 10px;

    span{
        font-size: 20px;
        font-weight:  700;
        color:#fff;
    }
    svg{
        height:18px;
        path{
            fill:#fff;
        }
    }
`; 

export const CloseButton = styled.button`
    margin-left: auto;
    border-radius:50%;
    height:34px;
    width:34px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;

    svg{
        height:50%;
        path{
            fill:#fff;
        }
    }

    :hover{
        transform: scale(1.1);
    }
`; 

export const NoteContainer = styled.div`
    height:100%;
    width:100%;
    overflow-y: scroll;
    position: relative;
    z-index: 1;
`; 

export const MessageContainer = styled.div`
    height:100%;
    width:100%;
    padding: 20px 20px 70px 20px;
    display: flex;
    flex-direction: column;
    gap:30px;
    overflow-y: scroll;
    position: relative;
    z-index: 1;

    ::-webkit-scrollbar{
        width:8px;
        height:100%;
        background:#dfdfdf4e;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb{
        background:#dfdfdf;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track{
        
    } 
`; 

export const NoNote = styled.div`
    position: absolute;
    width:70%;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    font-size: 36px;
    font-weight: 600;
    text-align: center;
`; 

export const InputContainer = styled.div`
    width:100%;
    padding:0 20px 20px 20px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    position: relative;
    z-index: 2;
`;

export const TextArea = styled.div<{inputDisable?:boolean}>`
    background: #fff;
    display:grid;
    grid-template-columns: 1fr 140px;
    grid-template-rows: ${props => props.inputDisable?"auto":"1fr auto"};
    padding:10px;
    border-radius: 5px;
    gap:10px;
    border:1px solid #2A848E;
    position: relative;

    textarea{
        display:${props => props.inputDisable?"none":"block"}; 
    }
  
    span {
      position: absolute;
      bottom: 50px;
      right: 10px
    }
    
    ${mq(Devices.mobile)}{
        grid-template-columns: 1fr 110px;

        span {
          position: absolute;
          bottom: 50px;
        }
    }
`; 

export const InputArea = styled.textarea`
    min-height: 60px;
    grid-column: span 2;
    resize: none;
    font-size:16px;
    outline: none;
    border:none;

    ::-webkit-scrollbar{
        width:8px;
        height:100%;
        background:#dfdfdf4e;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb{
        background:#dfdfdf;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track{
        
    } 
`;

export const NoteTags = styled.div<{inputDisable?:boolean}>`
    display: flex;
    align-items: ${props => props.inputDisable?"flex-start":"flex-end"};
    flex-wrap: wrap;
    gap:10px;
    min-height:${props => props.inputDisable?"80px":"auto"}; 
`; 

export const NoteTagsButton = styled(TagButton)<{c?:boolean}>`
    font-size: 16px;
    padding:5px 32px 4px 12px;
    position: relative;  
    color: ${props => props.c?"black":"#fff"};
    
    > div{
        position: absolute;
        right:6px;
        top:5px;
        display: flex;
        align-items: center;
        justify-content: center;
        height:18px;
        width:18px;
        border: ${props => props.c?"1px solid black":"1px solid #fff"};
        border-radius:5px;
        
        svg{
            height:60%;
            path{
                fill: ${props => props.c?"black":"#fff"};
            }
        }
    }
    
`; 

// export const AddNote = styled(TagButton)<{disable?:boolean}>`
//     background:${props => props.disable?"#2A848E":"#c0c0c0"};
//     font-size: 20px;
//     margin-top: auto;
//     padding:6px 0;

//     :hover{
//         transform: ${props => props.disable?"scale(1.05)":"none"} ;
//     }

//     ${mq(Devices.mobile)}{
//         font-size: 18px;
//     }
// `; 

export const DateSpilter = styled.div`
    
    display:grid;
    align-items: center;
    grid-template-columns: 1fr auto 1fr;
    gap:20px;
    font-size: 16px;
    font-weight: 500;
    color:${props => props.theme.colors.placeholderColor};

    > div{
        opacity: 0.5;
        height:1px; 
        width:100%;
        background:${props => props.theme.colors.placeholderColor};
    }
`; 

export const ButtonControls = styled.div`
    height:70px;
    width:calc(100% - 7px);
    display:flex;
    gap:20px;
    background:#fff;
    justify-content: end;
    position: absolute;
    bottom:0;
    left:0;
    z-index: 2;
    padding:20px;
`; 

export const Button = styled.div<{disable?:boolean}>`
    background:${props => props.disable?"#2A848E":"#c0c0c0"};
    font-size: 16px;
    margin-top: auto;
    padding:4px 20px;
    border-radius: 5px;
    color:#fff;
    min-width:110px;
    text-align: center;
    transition: all 0.1s ease-in-out;
    cursor: ${props => props.disable?"pointer":"unset"};
    pointer-events: ${props => props.disable?"all":"none"};

    :hover{
        background:${props => props.disable?"#1b6c75":"#c0c0c0"};
    }


    ${mq(Devices.mobile)}{
        font-size: 18px;
    }
`; 